import React from 'react'
import { PROVIDER_NETWORKS } from '../../constant'

interface Props {
  children?: React.ReactNode
}

const SwitchNetwork: React.FC<Props> = ({ children }) => {

  const switchNetwork = async () => {
    const chainId = process.env.REACT_APP_SUPPORT_CHAIN_ID
    const chainName = PROVIDER_NETWORKS.find((v) => v?.hex === chainId)?.name || ''
    const rpcUrl = process.env.REACT_APP_RPC_URL
    try {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: chainId }],
      })
    } catch (switchError: any) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                chainId: chainId,
                chainName: chainName,
                nativeCurrency: {
                  name: 'MATIC',
                  symbol: 'MATIC',
                  decimals: 18,
                },
                rpcUrls: [rpcUrl],
                blockExplorerUrls:
                  chainId === '0x13882' ? ['https://amoy.polygonscan.com/'] : ['https://polygonscan.com/'],
              },
            ],
          })
        } catch (addError) {
          // handle "add" error
        }
      }
      // handle other "switch" errors
    }
  }
  return (
    <div onClick={switchNetwork} role="presentation" className='cursor-pointer'>
      {children}
    </div>
  )
}

export default SwitchNetwork